'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lr = require('@lezer/lr');
var language = require('@codemirror/language');
var highlight = require('@lezer/highlight');

// This file was generated by lezer-generator. You probably shouldn't edit it.
const parser = lr.LRParser.deserialize({
  version: 14,
  states: "#fQVQPOOOOQO'#Cr'#CrOqQPO'#CqOOQO'#C^'#C^OvQQO'#ClQVQPOOO!hQPO,59]OVQPO,58xOOQO-E6j-E6jOVQPO'#CsOOQO1G.w1G.wOOQO1G.d1G.dO!oQPO'#CtO!wQPO,59_OVQPO'#CmO!|QPO,59`OOQO1G.y1G.yOOQO,59X,59XOOQO-E6k-E6k",
  stateData: "#U~OdOS~ORPOSPOTPOUPOVPOWPOXPOYPO~OZUO~O_VOR`XS`XT`XU`XV`XW`XX`XY`Xb`X~O[XO~PVO]^O^hX~O^`O~O]^O^ha~O",
  goto: "!giPPjPPPPPPPPPPPPPntPPPz!R!a!dTSOTQTORWTQ_[Rb_SROTRZVUQOTVQYUQ[XRa^RYUR]X",
  nodeNames: "⚠ Program Expression Variable Regex String Number ImplioList Boolean LineComment CustomSpecificFields Operator ( , ) LogicalOperator",
  maxTerm: 24,
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "3[~RjXY!sYZ!s]^!spq!srs#Ust%Rtu%jxy(vyz({|})Q!P!Q)V!Q![+V!^!_+j!`!a+j!b!c+w!c!d,o!d!e-Q!e!f-v!g!h.r!n!o/q!o!p0a!p!q0s!q!r1e!u!v1k#Y#Z2a#h#i3O~!xSd~XY!sYZ!s]^!spq!s~#XSO!P#e!Q;'S#e;'S;=`${<%lO#e~#hVOr#ers#}s#O#e#O#P$S#P;'S#e;'S;=`${<%lO#e~$SOT~~$VRO;'S#e;'S;=`$`;=`O#e~$cWOr#ers#}s#O#e#O#P$S#P;'S#e;'S;=`${;=`<%l#e<%lO#e~%OP;=`<%l#e~%WSX~OY%RZ;'S%R;'S;=`%d<%lO%R~%gP;=`<%l%R~%mUtu&P}!O&w!Q![&w!c!}&w#R#S&w#T#o&w~&ST}!O&c!Q![&c!c!}&c#R#S&c#T#o&c~&hTY~}!O&c!Q![&c!c!}&c#R#S&c#T#o&c~&|VR~}!O&w!O!P'c!Q![&w!c!}&w!}#O'u#R#S&w#T#o&w~'fT}!O&w!Q![&w!c!}&w#R#S&w#T#o&w~'xT}!O(X!Q![(X!c!}(X#R#S(X#T#o(X~([U}!O(X!Q![(X!c!}(X#P#Q(n#R#S(X#T#o(X~(sPR~!O!P'c~({O[~~)QO^~~)VO]~~)YVO!P)V!P!Q)o!Q#O)V#O#P*W#P;'S)V;'S;=`+P<%lO)V~)tUS~#Z#[)o#]#^)o#a#b)o#g#h)o#i#j)o#m#n)o~*ZRO;'S)V;'S;=`*d;=`O)V~*gWO!P)V!P!Q)o!Q#O)V#O#P*W#P;'S)V;'S;=`+P;=`<%l)V<%lO)V~+SP;=`<%l)V~+[QU~!O!P+b!Q![+V~+gPU~!Q![+bP+oPZP!_!`+rP+wOZP~+zT}!O,Z!Q![,Z!c!},Z#R#S,Z#T#o,Z~,`TV~}!O,Z!Q![,Z!c!},Z#R#S,Z#T#o,ZQ,rP!p!q,uQ,xP!f!g,{Q-QO_QP-TP!g!h-WP-ZP!v!w-^P-aP!y!z-dP-gP!g!h-jP-mP!g!h-pP-sP!p!q+rP-yP!q!r-|P.PP!p!q.SP.VP!v!w.YP.]P!c!d.`P.cP!k!l.fP.iP!p!q.lP.oP!u!v+rP.uQ!s!t.{!z!{/_P/OP!w!x/RP/UP!c!d/XP/[P!n!o.lP/bP!k!l/eP/hP!u!v/kP/nP!v!w.lP/tP!g!h/wP/zP!p!q/}P0QP!i!j0TP0WP!v!w0ZP0^P!j!k+rP0dP!c!d0gP0jP!v!w0mP0pP!e!f0ZR0vP!q!r0yR0|P!v!w1PR1UP_Qpq1XP1[R!d!e-Q!e!f-v!g!h.rQ1hP!t!u,{P1nP!k!l1qP1tP!o!p1wP1zP!k!l1}P2QP!n!o2TP2WP!c!d2ZP2^P!t!u+r~2dP#T#U2g~2jP#`#a2m~2pP#g#h2s~2vP#X#Y2y~3OOW~~3RP#f#g3U~3XP#i#j2s",
  tokenizers: [0, 1],
  topRules: {"Program":[0,1]},
  tokenPrec: 0
});

const BLANGLanguage = language.LRLanguage.define({
    parser: parser.configure({
        props: [
            language.indentNodeProp.add({
                Application: language.delimitedIndent({ closing: ")", align: false })
            }),
            language.foldNodeProp.add({
                Application: language.foldInside
            }),
            highlight.styleTags({
                Variable: highlight.tags.variableName,
                ImplioList: highlight.tags.list,
                Operator: highlight.tags.operator,
                Boolean: highlight.tags.bool,
                Number: highlight.tags.number,
                String: highlight.tags.string,
                Regex: highlight.tags.regexp,
                LineComment: highlight.tags.lineComment,
                CustomSpecificFields: highlight.tags.special(highlight.tags.variableName),
                LogicalOperator: highlight.tags.controlKeyword,
                "( )": highlight.tags.paren,
                ",": highlight.tags.punctuation
            })
        ]
    }),
    languageData: {
        commentTokens: { line: ";" }
    }
});
function BLANG() {
    return new language.LanguageSupport(BLANGLanguage);
}

exports.BLANG = BLANG;
exports.BLANGLanguage = BLANGLanguage;
